import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

import { LoginModel } from "@core/models/login.model";
import { User } from "@core/models/user.model";
import { AuthService } from "@core/services/auth.service";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Action, Store } from "@ngrx/store";
import { catchError, mergeMap, Observable, of, switchMap } from "rxjs";

import * as AuthActions from "./auth.actions";
import { LOGIN_FAILED, SET_LOGIN_LOADING } from "./auth.actions";

@Injectable()
export class AuthEffects {
  getLogin$ = createEffect((): Observable<any> => {
    return this.actions$.pipe(
      ofType(AuthActions.DO_INITIAL_LOGIN),
      mergeMap((): Observable<Action> => {
        return this.authService.getLoginInitialCookie$().pipe(
          switchMap((): Observable<any> => {
            return of();
          })
        );
      })
    );
  });

  login$ = createEffect((): Observable<Action> => {
    return this.actions$.pipe(
      ofType(AuthActions.DO_LOGIN),
      mergeMap(
        (action: {
          credentials: LoginModel;
          target: string;
        }): Observable<Action> => {
          this.store.dispatch(SET_LOGIN_LOADING({ loading: true }));
          return this.authService.login$(action.credentials).pipe(
            switchMap((): Observable<Action> => {
              this.store.dispatch(SET_LOGIN_LOADING({ loading: false }));
              return this.authService.getUserData$().pipe(
                switchMap((user: User): Observable<Action> => {
                  this.router.navigate([`${action.target}`]).then();
                  return of(AuthActions.LOGIN_SUCCESS({ User: user }));
                })
              );
            }),
            catchError((error: HttpErrorResponse): Observable<Action> => {
              this.store.dispatch(LOGIN_FAILED({ error }));
              return of(SET_LOGIN_LOADING({ loading: false }));
            })
          );
        }
      )
    );
  });

  logout$ = createEffect((): Observable<Action> => {
    return this.actions$.pipe(
      ofType(AuthActions.DO_LOGOUT),
      mergeMap((): Observable<Action> => {
        this.authService.logout$();
        return of();
      })
    );
  });

  loadUserData$ = createEffect((): Observable<Action> => {
    return this.actions$.pipe(
      ofType(AuthActions.LOAD_USER_DATA),
      mergeMap((): Observable<Action> => {
        return this.authService.getUserData$().pipe(
          switchMap((user: User): Observable<Action> => {
            return of(AuthActions.SET_USER_DATA({ user }));
          })
        );
      }),
      catchError((): Observable<Action> => {
        return of();
      })
    );
  });

  constructor(
    private actions$: Actions,
    private authService: AuthService,
    private store: Store,
    private router: Router
  ) {}
}
